export default {
  "hero.badge": "Independent Resource • Regularly Updated • Safety-Focused",
  "hero.title": "USFans Spreadsheet — Explore USFans Creators, Guides & Resources",
  "hero.subtitle": "Explore a structured USFans spreadsheet and resource hub designed to help you discover creator information, compare resources, understand shipping and costs, and find useful USFans guides in one place.",
  "hero.ctaPrimary": "Explore USFans Spreadsheet",
  "hero.ctaSecondary": "Browse USFans Guides",
  "hero.trust": "Independent Resource • Regularly Updated • Safety-Focused",

  "heroSupport.title": "Looking for a simpler way to explore USFans information?",
  "heroSupport.body": "Our USFans Spreadsheet organizes useful information into an easy-to-browse structure. Explore categories, guides, comparisons, FAQs and practical resources from one central hub.",
  "heroSupport.cta": "Open the USFans Spreadsheet",

  "value.title": "Everything You Need to Know About USFans in One Place",
  "value.subtitle": "Six core resources, all organized for faster, safer research.",
  "value.spreadsheet.title": "USFans Spreadsheet",
  "value.spreadsheet.body": "Explore structured information through an easy-to-navigate spreadsheet-style resource.",
  "value.directory.title": "Creator Directory",
  "value.directory.body": "Browse creator-related resources and categories in a clean, organized view.",
  "value.reviews.title": "USFans Reviews",
  "value.reviews.body": "Understand what to consider when evaluating USFans and related services.",
  "value.shipping.title": "Shipping & Costs",
  "value.shipping.body": "Explore shipping, warehouse and cost-related guides to plan ahead.",
  "value.coupons.title": "Coupons & Discounts",
  "value.coupons.body": "Find information about coupons, discount codes and promotions.",
  "value.safety.title": "Safety Center",
  "value.safety.body": "Learn how to identify suspicious links and protect your information.",

  "spreadsheet.title": "The USFans Spreadsheet",
  "spreadsheet.body": "The USFans Spreadsheet is the core resource of USFansLink.wiki. It organizes useful creator and resource information into a structured format so visitors can browse, compare and discover information more efficiently.",
  "spreadsheet.colCreator": "Creator / Resource",
  "spreadsheet.colCategory": "Category",
  "spreadsheet.colType": "Type",
  "spreadsheet.colInfo": "Information",
  "spreadsheet.colUpdated": "Updated",
  "spreadsheet.rowTypeProfile": "Profile",
  "spreadsheet.rowTypeGuide": "Guide",
  "spreadsheet.rowTypeResource": "Resource",
  "spreadsheet.view": "View Resource",
  "spreadsheet.cta": "Explore the Full USFans Spreadsheet →",
  "spreadsheet.group.footwear": "Footwear",
  "spreadsheet.group.apparel": "Apparel",
  "spreadsheet.group.accessories": "Accessories",
  "spreadsheet.group.other": "Other",

  "search.title": "Popular USFans Searches",
  "search.subtitle": "Jump to the topics people search for most.",
  "search.review.title": "USFans Review",
  "search.review.body": "What to consider before trusting a USFans resource.",
  "search.shipping.title": "USFans Shipping Cost",
  "search.shipping.body": "A practical look at shipping, methods and timing.",
  "search.coupon.title": "USFans Coupon",
  "search.coupon.body": "Where to look for coupons and what to expect.",
  "search.discount.title": "USFans Discount Code",
  "search.discount.body": "How discount codes work and how to verify them.",
  "search.warehouse.title": "USFans Warehouse",
  "search.warehouse.body": "Understand the warehouse process and its role.",
  "search.legit.title": "Is USFans Legit?",
  "search.legit.body": "A balanced guide to evaluating legitimacy safely.",

  "compare.title": "USFans Resources Compared",
  "compare.colResource": "Resource",
  "compare.colBestFor": "Best For",
  "compare.colGuides": "Guides",
  "compare.colComparison": "Comparison",
  "compare.colSafety": "Safety",
  "compare.rowSpreadsheet": "USFans Spreadsheet",
  "compare.rowSpreadsheetBest": "Organized browsing",
  "compare.rowDirectory": "Creator Directory",
  "compare.rowDirectoryBest": "Discovery",
  "compare.rowShipping": "Shipping Guide",
  "compare.rowShippingBest": "Shipping research",
  "compare.rowReview": "Review Guide",
  "compare.rowReviewBest": "Evaluation",

  "how.title": "How the USFans Resource Hub Works",
  "how.subtitle": "A simple four-step process to research with confidence.",
  "how.step1.title": "Explore",
  "how.step1.body": "Find the USFans Spreadsheet or a specific topic.",
  "how.step2.title": "Compare",
  "how.step2.body": "Use guides and tables to understand differences.",
  "how.step3.title": "Verify",
  "how.step3.body": "Review safety information before visiting external websites.",
  "how.step4.title": "Continue",
  "how.step4.body": "Visit the main website when additional resources are relevant.",
  "how.cta": "Explore USFans Spreadsheet",

  "trust.title": "Built for Better USFans Research",
  "trust.subtitle": "Clear standards, transparent information and honest guidance.",
  "trust.item1": "Independent resource platform",
  "trust.item2": "Editorial content",
  "trust.item3": "Clear update dates",
  "trust.item4": "Safety guidance",
  "trust.item5": "Transparent disclaimer",
  "trust.item6": "No fake reviews",
  "trust.item7": "No fabricated statistics",
  "trust.about": "About Us",
  "trust.editorial": "Editorial Policy",
  "trust.update": "Update Policy",
  "trust.safetyLink": "Safety Center",

  "faq.title": "Frequently Asked Questions",
  "faq.subtitle": "Quick answers to the most common USFans Spreadsheet questions.",
  "faq.q1": "What is a USFans spreadsheet?",
  "faq.a1": "A USFans spreadsheet is a structured resource that organizes creator, category and reference information into a single, easy-to-browse format.",
  "faq.q2": "How does the USFans spreadsheet work?",
  "faq.a2": "It groups related information into rows and categories so you can scan, compare and jump to relevant resources without opening many separate pages.",
  "faq.q3": "What information can I find?",
  "faq.a3": "You can find creator references, category links, guides, and practical resources related to exploring USFans content.",
  "faq.q4": "Is USFans legit?",
  "faq.a4": "We provide guidance on how to evaluate legitimacy rather than making a single verdict. Always verify sources and avoid suspicious links.",
  "faq.q5": "How much does USFans shipping cost?",
  "faq.a5": "Shipping costs can vary by region, method and order. Check the latest details on the main website before purchasing.",
  "faq.q6": "Does USFans offer coupons?",
  "faq.a6": "Coupons and promotions may appear from time to time. We recommend verifying any active offer on the main website directly.",
  "faq.q7": "What is a USFans discount code?",
  "faq.a7": "A discount code is a short text you enter at checkout to apply a promotion. Always confirm a code is current before use.",
  "faq.q8": "How does the USFans warehouse work?",
  "faq.a8": "The warehouse handles storage and dispatch of orders. Processing times can depend on location and stock availability.",
  "faq.q9": "How should I evaluate USFans reviews?",
  "faq.a9": "Look for consistent, detailed feedback across multiple sources rather than relying on a single opinion or rating.",
  "faq.q10": "Is USFansLink.wiki officially affiliated with USFans?",
  "faq.a10": "No. USFansLink.wiki is an independent informational resource and is not affiliated with or endorsed by USFans.",

  "finalCta.title": "Start Exploring the USFans Spreadsheet",
  "finalCta.body": "Browse structured USFans resources, guides, comparisons and safety information from one central hub.",
  "finalCta.primary": "Explore USFans Spreadsheet",
  "finalCta.secondary": "Visit Main Website",

  "pillar.title": "USFans Guides & Resources",
  "pillar.subtitle": "Original, in-depth guides covering reviews, shipping, coupons, safety and more.",
  "pillar.readMore": "Read Guide",
};